import type { SVGProps } from 'react';

const SvgDatabaseAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="m20.3 19.6-7.8-7.8c.9-1.3.8-3-.3-4.1-1.3-1.2-3.2-1.2-4.5 0-1.2 1.2-1.2 3.2 0 4.5 1.1 1.1 2.8 1.2 4.1.3l7.8 7.8c-1 1.4-.7 3.4.7 4.4s3.4.7 4.4-.7c.9-1.3.8-3-.3-4.1-1.2-1.1-2.9-1.2-4.1-.3M8.4 11.4c-.8-.8-.8-2.2 0-3.1.8-.8 2.2-.8 3.1 0 .8.8.8 2.2 0 3-.9 1-2.3 1-3.1.1m15.2 12.2c-.8.8-2.2.8-3.1 0-.8-.8-.8-2.2 0-3.1.8-.8 2.2-.8 3.1 0s.9 2.3 0 3.1"
    />
    <path
      fill={props.color}
      d="M19.9 7.7c-1.1 1.1-1.2 2.8-.3 4.1L17 14.3l.7.7 2.6-2.6c1.4 1 3.4.7 4.4-.7.9-1.3.8-3-.3-4.1-1.3-1.2-3.3-1.2-4.5.1m3.7 3.7c-.8.8-2.2.8-3.1 0-.8-.8-.8-2.2 0-3.1.8-.8 2.2-.8 3.1 0s.9 2.3 0 3.1"
    />
    <path
      fill={props.color}
      d="M16 .4C7.4.4.4 7.4.4 16s7 15.6 15.6 15.6 15.6-7 15.6-15.6S24.6.4 16 .4m0 30.2C7.9 30.6 1.4 24.1 1.4 16S7.9 1.4 16 1.4 30.6 7.9 30.6 16 24.1 30.6 16 30.6"
    />
    <path
      fill={props.color}
      d="m14.4 16.9-2.7 2.6c-1.3-.9-3-.7-4.1.3-1.2 1.2-1.2 3.2 0 4.5 1.2 1.2 3.2 1.2 4.5 0 1.1-1.1 1.2-2.8.3-4.1l2.7-2.6zm-3 6.7c-.8.8-2.2.8-3.1 0-.8-.8-.8-2.2 0-3.1.8-.8 2.2-.8 3.1 0 .8.9.9 2.3 0 3.1"
    />
  </svg>
);

export default SvgDatabaseAlt;
